module.exports = __webpack_public_path__ + "img/Virtual_Good.f541b5ec.png";